import PropTypes from "prop-types";
import { CustomContainer, Form, Col } from "../../DependencyHelper";
import formStyles from "../CheckoutForms.module.scss";

const SpecialInstruction = ({
  formName,
  variant,
  fieldValues,
  fieldErrors,
  fieldErrorsMessage,
  readOnlyValues,
  onChangeHandler,
  onBlurHandler,
  className,
}) => {
  const handleChange = (event) => {
    onChangeHandler(event, null, formName);
  };

  const handleBlur = (event) => {
    onBlurHandler(event, null, formName);
  };

  return (
    <CustomContainer
      className={`${formStyles[variant]} ${formStyles["main-container"]} ${className}`}
    >
      <Form.Row className={formStyles["main-row"]}>
        <Form.Group
          as={Col}
          sm="12"
          md="12"
          className={formStyles["form-group"]}
          controlId={`validationFormsi101-${variant}`}
        >
          <Form.Control
            as="textarea"
            name="instructions"
            placeholder="e.g. Please call me when you're at the gate"
            value={fieldValues["instructions"]}
            onChange={handleChange}
            onBlur={handleBlur}
            readOnly={readOnlyValues["instructions"]}
            isInvalid={fieldErrors["instructions"]}
            className={
              fieldErrors.instructions
                ? `${formStyles["form-control-area"]} ${formStyles["invalid"]}`
                : formStyles["form-control-area"]
            }
          ></Form.Control>
          <Form.Control.Feedback
            type="invalid"
            className={formStyles["invalid-feedback"]}
          >
            {fieldErrorsMessage["instructions"]}
          </Form.Control.Feedback>
          {!fieldErrors["instructions"] && (
            <div className={formStyles["hint-text"]}>
              {"Deliveries are made on weekdays between 08:00 and 17:00"}
            </div>
          )}
        </Form.Group>
      </Form.Row>
    </CustomContainer>
  );
};

SpecialInstruction.propTypes = {
  variant: PropTypes.oneOf(["plain", "popup"]),
  formName: PropTypes.oneOf(["instructions"]),
  fieldValues: PropTypes.object,
  fieldErrors: PropTypes.object,
  fieldErrorsMessage: PropTypes.object,
  readOnlyValues: PropTypes.object,
  onChangeHandler: PropTypes.func,
  onBlurHandler: PropTypes.func,
};

SpecialInstruction.defaultProps = {
  formName: "instructions",
  variant: "plain",
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  readOnlyValues: {},
};

export default SpecialInstruction;
